export default {
    actionUndo: {
        message: "Als je per ongeluk hebt geklikt, klik dan op de onderstaande link om terug te gaan.",
        undo: "Klik om ongedaan te maken"
    }
}